import React from 'react'
import EventAvailableOutlinedIcon from '@mui/icons-material/EventAvailableOutlined'
import { Box, Tooltip, Typography } from '@mui/material'
import SchoolOutlinedIcon from '@mui/icons-material/SchoolOutlined'
import DocumentScannerOutlinedIcon from '@mui/icons-material/DocumentScannerOutlined'
import DateRangeOutlinedIcon from '@mui/icons-material/DateRangeOutlined'
import { type ISlot } from '../../../models/DistributionPlan'
import { format } from 'date-fns'
import { ReleaseMode } from '../../../helpers/parseReleaseTimestamp'
interface DistributionPlanDetailsProps {
  slot: ISlot
}
interface DetailItem {
  title: string
  icon: JSX.Element
  value?: string
}
const formatDateByUserTimeZone = (timestamp: number | Date): string => {
  if (!timestamp) return ''
  const date = timestamp instanceof Date ? timestamp : new Date(timestamp)
  return format(date, 'MM/dd/yyyy hh:mm a')
}
const DistributionPlanDetails: React.FC<DistributionPlanDetailsProps> = ({ slot }) => {
  const releaseTimestamp = slot.releaseTimestamp
  const startTimestamp = slot.slotStartTimestamp
  const endTimestamp = slot.slotEndTimestamp
  const rollingRelease = slot.isRollingResultsEnabled
  const formattedResultsDate = releaseTimestamp === ReleaseMode.Rolling ? releaseTimestamp : formatDateByUserTimeZone(releaseTimestamp as Date)
  const formattedStartDate = formatDateByUserTimeZone(startTimestamp)
  const formattedEndDate = formatDateByUserTimeZone(endTimestamp)
  const details: DetailItem[] = [
    { title: 'Term', icon: <SchoolOutlinedIcon />, value: slot?.term?.termName },
    { title: 'Survey Template', icon: <DocumentScannerOutlinedIcon />, value: slot?.surveyTemplate?.title },
    { title: 'Survey Date Range', icon: <DateRangeOutlinedIcon />, value: `${formattedStartDate} - ${formattedEndDate}` },
    rollingRelease
      ? { title: 'Rolling Results', icon: <EventAvailableOutlinedIcon />, value: 'Rolling Results' }
      : { title: 'Default Report Release Date', icon: <EventAvailableOutlinedIcon />, value: formattedResultsDate }
  ]
  return (
    <Box>
      <Typography tabIndex={0} variant="h3">
        <Box display="flex" alignItems="center" height="100%" flexWrap="wrap" gap={3}>
          {details.map(({ title, icon, value }) => (
            <Tooltip key={title} title={title} placement='bottom-start'>
              <Box display="flex" alignItems="center" gap={0.75} height="100%" flexWrap="nowrap">{icon}{value}</Box>
            </Tooltip>
          ))}
        </Box>
      </Typography>
    </Box>
  )
}
export default DistributionPlanDetails
